import moment, { Moment } from 'moment-timezone';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';

export class ViolationHistory
{
    violationId: number;
    creator: string;
    recipient: string;
    eventName: string;
    eventType: string;
    content: string;
    previousStatus: string;
    currentStatus: string;
    createdAt: Moment;

    constructor(request: any) {
        this.violationId = request.violationId || '';
        this.creator = request.creator;
        this.recipient = request.recipient;
        this.eventName = request.eventName || '';
        this.eventType = request.eventType || '';
        this.content = request.content || '';

        const timezone = LegFiJwtService.getTimezone();
        if (request.createdAt) {
            this.createdAt = moment.utc(request.createdAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }

        // stored as "prevStat | currStat" in database
        if (request.eventType === 'status') {
            const splitStr = request.content.split('|');
            this.previousStatus = splitStr[0].trim();
            this.currentStatus = splitStr[1].trim();
        }
    }
}
